import { useEffect, useState } from "react"
import { FaPhone, FaEnvelope, FaMapLocationDot, FaPaperPlane, FaCircleCheck } from "react-icons/fa6";

const ClientForm = () => {

    const host = `https://serverapp.samligne-express.com/api`;

    const [wilayas,setWilaya] = useState([]);
    const [communes,setCommunes] = useState([]);
    const [errorInfo,setErrorInfo] = useState("");
    const [done,setDone] = useState(false);

    const [formData, setFormData] = useState({

        fullname: '',
        type: '',
        phone_1: '',
        email_1: '',
        address: '',
        wilaya: '',
        commune: '',
        username: '',
        password: '',
        password_c: '',

    });

    const handleChange = (e) => {

        const { name, value } = e.target;

        //setFormData({ ...formData, [name]: value});
        setFormData(prev => ({...prev,[name]: value}));

        if (name == "wilaya") loadCommunes(e.target.value)

    };

    useEffect(() => {

        loadWilayas()

    },[]);

    function loadWilayas() {

        fetch(`${host}/wilayas`)
        .then(res => res.json())
        .then(results => {

            const wilayas = results["data"]["wilayas"];
            setWilaya(wilayas)

        })
        .catch(error => console.log("failed to load wilayas"))

    }

    function loadCommunes(wilaya) {

        fetch(`${host}/communes/${wilaya}`)
        .then(res => res.json())
        .then(results => {

            const communes = results["data"]["communes"];
            setCommunes(communes)

        })
        .catch(error => console.log("failed to load communes"))

    }

    function register(fetchBody) {

        fetch(`${host}/sender_client/register`,{
            headers: {'Accept': 'application/json','Content-Type': 'application/json'},
            method : "POST",
            body  : JSON.stringify(fetchBody)
        })
        .then(res => res.json())
        .then(result => {

            if (result["err"]) {

                if (result["err"]["code"] == "DATA_MISSED") setErrorInfo("Veuillez renseigner les champs obligatoires.")
                else if (result["err"]["code"] == "PASSWORD_CONFIRMATION_ERROR") setErrorInfo("La confirmation du mot de passe ne correspond pas.")
                else if (result["err"]["code"] == "PASSWORD_LENGTH_ERROR_6_MIN") setErrorInfo("Le mot de passe doit contenir au minimum 6 caractères.")
                else if (result["err"]["code"] == "USERNAME_EXISTS") setErrorInfo("Ce nom d'utilisateur est déjà utilisée.")
                else if (result["err"]["code"] == "SENDER_CLIENT_TYPE_INVALID") setErrorInfo("Type de client invalide.")
                else setErrorInfo("Une erreur est survenue. L’opération n’a pas pu être effectuée.");

            } else setDone(true)

        })
        .catch(error => {

            console.error(error);
            setErrorInfo("Une erreur est survenue. L’ajout en attente n’a pas pu être effectué.")

        })

    }

    const handleSubmit = (e) => {

        e.preventDefault();
        register(formData);

    };

    return (

        <div className="animate-in slide-in-from-bottom-8 fade-in duration-500 w-100">

            <div className="bg-white p-8 rounded-3xl shadow-2xl overflow-hidden flex items-center">

                {

                    !done ?

                        <form onSubmit={handleSubmit} className="space-y-6  text-start">

                            <h3 className="font-semibold text-lg text-blue-500">INFORMATIONS PERSONNELLES</h3>
                            <hr />

                            <div className="lg:columns-2">

                                <div className="mb-5">
                                    <label className="text-sm font-bold text-slate-700 ml-1">Nom complet / Raison social <span className="text-gray-400">( OBLIGATOIRE )</span></label>
                                    <input type="text" name="fullname" value={formData.name} onChange={handleChange} required
                                        className="w-full mt-3  px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all font-medium text-slate-700" placeholder="" />
                                </div>
                                <div className="mb-5">
                                    <label className="text-sm font-bold text-slate-700 ml-1">vous êtes ?</label>
                                    <select
                                        name="type"
                                        value={formData.type}
                                        onChange={handleChange}
                                        className="w-full rounded-md border border-gray-300 bg-white px-3 py-3 text-sm mt-3
                                                    focus:outline-none focus:ring-2 focus:ring-blue-500">
                                        <option value="">...</option>
                                        <option value="1">Un particulier</option>
                                        <option value="2">Une entreprise</option>
                                    </select>
                                </div>

                            </div>

                            <div className="lg:columns-2">
                                <div className="mb-5">
                                    <label className="text-sm font-bold text-slate-700 ml-1">Téléphone <span className="text-gray-400">( OBLIGATOIRE )</span></label>
                                    <input type="tel" name="phone_1" value={formData.phone_1} onChange={handleChange} required
                                        className="w-full mt-3  px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all font-medium text-slate-700" placeholder="" />
                                </div>

                                <div className="mb-5">
                                    <label className="text-sm font-bold text-slate-700 ml-1">Email</label>
                                    <input type="email" name="email_1" value={formData.email_1} onChange={handleChange}
                                        className="w-full mt-3  px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all font-medium text-slate-700" placeholder="" />
                                </div>
                            </div>

                            <div className="mb-5">
                                <label className="text-sm font-bold text-slate-700 ml-1">Adresse</label>
                                <input type="text" name="address" value={formData.address} onChange={handleChange}
                                    className="w-full mt-3 px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all font-medium text-slate-700" placeholder="" />
                            </div>

                            <div className="lg:columns-2">

                                <div className="mb-5">
                                    <label className="text-sm font-bold text-slate-700 ml-1">Wilaya <span className="text-gray-400">( OBLIGATOIRE )</span></label>
                                    <select
                                        required
                                        name="wilaya"
                                        value={formData.wilaya}
                                        onChange={handleChange}
                                        className="w-full rounded-md border border-gray-300 bg-white px-3 py-3 text-sm mt-3
                                                    focus:outline-none focus:ring-2 focus:ring-blue-500">
                                        <option value="">Sélectionner une wilaya</option>
                                        {wilayas.map(w => (

                                            <option value={w.wilaya_id}>{w.wilaya_id + "-" + w.wilaya_name + "-" + w.wilaya_name_ar}</option>

                                        ))}
                                    </select>
                                </div>

                                <div className="mb-5">
                                    <label className="text-sm font-bold text-slate-700 ml-1">Commune <span className="text-gray-400">( OBLIGATOIRE )</span></label>
                                    <select
                                        required
                                        name="commune"
                                        value={formData.commune}
                                        onChange={handleChange}
                                        className="w-full rounded-md border border-gray-300 bg-white px-3 py-3 text-sm mt-3
                                                    focus:outline-none focus:ring-2 focus:ring-blue-500">
                                        <option value="">Sélectionner une commune</option>
                                        {communes.map(c => (

                                            <option value={c.commune_id}>{c.commune_name + "-" + c.commune_name_ar}</option>

                                        ))}
                                    </select>
                                </div>

                            </div>

                            <h3 className="font-semibold text-lg text-blue-500">COMPTE</h3>
                            <hr />

                            <div>
                                <label className="text-sm font-bold text-slate-700 ml-1">Nom d'utilisateur <span className="text-gray-400">( OBLIGATOIRE )</span></label>
                                <input type="text" name="username" value={formData.username} onChange={handleChange} required
                                    className="w-full mt-3  px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all font-medium text-slate-700" placeholder="" />
                            </div>

                            <div className="lg:columns-2">
                                <div className="mb-5">
                                    <label className="text-sm font-bold text-slate-700 ml-1">Mot de passe <span className="text-gray-400">( OBLIGATOIRE )</span></label>
                                    <input type="password" name="password" value={formData.password} onChange={handleChange} required
                                        className="w-full mt-3 px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all font-medium text-slate-700" placeholder="" />
                                </div>

                                <div>
                                    <label className="text-sm font-bold text-slate-700 ml-1">Confirmation mot de passe <span className="text-gray-400">( OBLIGATOIRE )</span></label>
                                    <input type="password" name="password_c" value={formData.password_c} onChange={handleChange} required
                                        className="w-full mt-3  px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all font-medium text-slate-700" placeholder="" />
                                </div>
                            </div>
                            <hr />
                            <h3 className="font-semibold text-lg text-red-600">{errorInfo}</h3>
                            <button type="submit" className="w-full py-4 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl transition-all shadow-lg hover:shadow-blue-500/30 flex items-center justify-center gap-2 mt-4">
                                <FaCircleCheck /> Valider
                            </button>
                        </form>

                    :

                    <div className="flex flex-col items-center justify-center gap-5 p-5">
                        <FaCircleCheck className="text-6xl text-green-500"/>

                        <h3 className="font-semibold">Votre compte a été enregistré avec succès</h3>
                        <p className="text-sm">
                            Merci pour votre inscription.
                            <br />
                            Notre équipe vous contactera dans les plus brefs délais pour finaliser l’activation de votre compte.
                        </p>

                    </div>

                }

            </div>

        </div>

    )

}

export default ClientForm
